import classes from './SideDrawer.module.scss'
import { useContext } from 'react'
import BackDrop from '../../UI/Backdrop/Backdrop'
import { Avatar } from '@chakra-ui/react'
import { NavLink, useNavigate } from 'react-router-dom'
import AuthContext from '../../../store/auth-context'
const navLinks = [
    { name: "Dashboard", link: "/"},
    { name: "Auction", link: "/auction"},
    { name: "Dealer Stock", link: "/dealer-stock"},
    { name: "My Garage", link: "/garage"},
    { name: "Guide", link: "/guide"},
    { name: "Profile", link: "/profile"},

    {
        name: "Logout",
        link: "/login"
    },{
        name: "Management",
        link: "/management",
        adminOnly: true
    }
]

const SideDrawer = ({open, closed}) => {

    let attachedClasses = [classes.SideDrawer, classes.Close]

    if (open) {
        attachedClasses = [classes.SideDrawer, classes.Open]
    }
    const auth = useContext(AuthContext);
    const navigate = useNavigate();
    const isAdmin = auth.userData?.userRole === "administrator";
    const fullName = `${auth?.userData?.firstName || ''} ${auth?.userData?.lastName || ''}`.trim();

    return (
        <>
            <BackDrop show={open} clicked={closed} className={classes.DrawerBackdrop}/>
            <div className={attachedClasses.join(' ')} >
                {/* The drawer now covers the header's hamburger, so it closes itself. */}
                <div className={classes.SideNavHeader}>
                    <Avatar
                        name={fullName}
                        src={auth?.userData?.image || "https://mmpubimages.s3.us-west-1.amazonaws.com/defaultprofile.png"}
                        onError={(e) => {
                            console.log("Error loading profile image:", e);
                            e.target.src = "https://mmpubimages.s3.us-west-1.amazonaws.com/defaultprofile.png";
                        }}
                    />
                    {fullName && <span className={classes.UserName}>{fullName}</span>}
                    <button type="button" className={classes.CloseBtn} onClick={closed} aria-label="Close menu">
                        <i className="fas fa-times" aria-hidden="true"></i>
                    </button>
                </div>
                <nav className={classes.SideNavDiv} onClick={closed}>
                    {navLinks.map(navlink =>
                        (!navlink.adminOnly || (navlink.adminOnly && isAdmin)) && (
                            <NavLink
                                key={navlink.name}
                                to={navlink.link}
                                onClick={navlink.name === "Logout" ? () => {
                                    auth.logout();
                                    navigate('/login');
                                } : null}
                                className={({ isActive }) => isActive ? classes.ActiveSideLink : ''}>

                                {navlink.name}
                            </NavLink>
                        )
                    )}
                </nav>

            </div>
        </>
    )
}

export default SideDrawer;
